/* eslint-disable */ import { childEntityRecipesComponent, memoEval, sceneEntityDeleteFabComponent, selectableComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const segmentComponents = [
    attachComponent.withComponent(sceneEntityDeleteFabComponent, 'default', true).withAlias('Segment').withGradualFilter({
        modes: [
            'owner'
        ]
    }).attach(memoEval((self)=>[
            self.$fabCenteredOffsetX,
            self.$fabOffsetY
        ], ($fabCenteredOffsetX, $fabOffsetY)=>({
            offsetX: $fabCenteredOffsetX,
            offsetY: $fabOffsetY,
            offsetZ: 12
        }))),
    attachComponent.withComponent(childEntityRecipesComponent, 'baseCabinet', true).withAlias('Segment').attach(memoEval((self)=>[
            self.$baseCabinetRecipes
        ], ($baseCabinetRecipes)=>({
            groupLabel: 'Base Cabinet',
            recipes: $baseCabinetRecipes
        }))),
    attachComponent.withComponent(childEntityRecipesComponent, 'tallCabinet', true).withAlias('Segment').attach(memoEval((self)=>[
            self.$tallCabinetRecipes
        ], ($tallCabinetRecipes)=>({
            groupLabel: 'Tall Cabinet',
            recipes: $tallCabinetRecipes
        }))),
    attachComponent.withComponent(childEntityRecipesComponent, 'wallCabinet', true).withAlias('Segment').attach(memoEval((self)=>[
            self.$wallCabinetRecipes
        ], ($wallCabinetRecipes)=>({
            groupLabel: 'Wall Cabinet',
            recipes: $wallCabinetRecipes
        }))),
    attachComponent.withComponent(childEntityRecipesComponent, 'wallCabinetAbove', true).withAlias('Segment').attach(memoEval((self)=>[
            self.$wallCabinetAboveRecipes
        ], ($wallCabinetAboveRecipes)=>({
            groupLabel: 'Wall Cabinet',
            recipes: $wallCabinetAboveRecipes
        }))),
    attachComponent.withComponent(childEntityRecipesComponent, 'baseCabinetLeft', true).withAlias('Segment').attach(memoEval((self)=>[
            self.$baseCabinetLeftRecipes
        ], ($baseCabinetLeftRecipes)=>({
            groupLabel: 'Base Cabinet',
            recipes: $baseCabinetLeftRecipes
        }))),
    attachComponent.withComponent(childEntityRecipesComponent, 'tallCabinetLeft', true).withAlias('Segment').attach(memoEval((self)=>[
            self.$tallCabinetLeftRecipes
        ], ($tallCabinetLeftRecipes)=>({
            groupLabel: 'Tall Cabinet',
            recipes: $tallCabinetLeftRecipes
        }))),
    attachComponent.withComponent(childEntityRecipesComponent, 'wallCabinetLeft', true).withAlias('Segment').attach(memoEval((self)=>[
            self.$wallCabinetLeftRecipes
        ], ($wallCabinetLeftRecipes)=>({
            groupLabel: 'Wall Cabinet',
            recipes: $wallCabinetLeftRecipes
        }))),
    attachComponent.withComponent(childEntityRecipesComponent, 'noCabinet', true).withAlias('Segment').attach(memoEval((self)=>[
            self.$noCabinetRecipes
        ], ($noCabinetRecipes)=>({
            groupLabel: 'No Cabinet',
            recipes: $noCabinetRecipes
        }))),
    attachComponent.withComponent(childEntityRecipesComponent, 'noCabinetLeft', true).withAlias('Segment').attach(memoEval((self)=>[
            self.$noCabinetLeftRecipes
        ], ($noCabinetLeftRecipes)=>({
            groupLabel: 'No Cabinet',
            recipes: $noCabinetLeftRecipes
        }))),
    attachComponent.withComponent(childEntityRecipesComponent, 'emptySpace', true).withAlias('Segment').attach(memoEval((self)=>[
            self.$emptySpaceRecipes
        ], ($emptySpaceRecipes)=>({
            groupLabel: 'Empty Space',
            recipes: $emptySpaceRecipes
        }))),
    attachComponent.withComponent(childEntityRecipesComponent, 'emptySpaceLeft', true).withAlias('Segment').attach(memoEval((self)=>[
            self.$emptySpaceLeftRecipes
        ], ($emptySpaceLeftRecipes)=>({
            groupLabel: 'Empty Space',
            recipes: $emptySpaceLeftRecipes
        }))),
    attachComponent.withComponent(selectableComponent, 'default', true).withAlias('Segment').attach(memoEval(()=>[], ()=>({})))
];

//# sourceMappingURL=segment.js.map